export default __webpack_public_path__ + "static/media/flower-computer.7283bc79.png";